import { render, staticRenderFns } from "./AddressDetail.vue?vue&type=template&id=869e6454&scoped=true"
import script from "./AddressDetail.vue?vue&type=script&lang=js"
export * from "./AddressDetail.vue?vue&type=script&lang=js"
import style0 from "./AddressDetail.vue?vue&type=style&index=0&id=869e6454&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869e6454",
  null
  
)

export default component.exports